import { AnimatePresence, motion } from "motion/react";

import useModalRouter from "@/hooks/useModalRouter";

import modalRoutes from "./ModalRoutes";

const ModalOutlet = (): JSX.Element | null => {
  const { currentModal } = useModalRouter();

  const pathParts = currentModal?.split("/") ?? [];

  if (pathParts.length == 1) return null;

  const [base, rest] = pathParts;

  const parentRoute = modalRoutes.find((parent) => {
    return base == parent.name;
  });

  const childRoute = parentRoute?.children?.find((child) => {
    return rest == child.name;
  });

  const Component = childRoute?.component;

  if (!Component) return null;

  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={childRoute.name}
        initial={{ opacity: 0, scale: 1.1 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.3, ease: "easeInOut" }}
      >
        {Component && <Component />}
      </motion.div>
    </AnimatePresence>
  );
};

export default ModalOutlet;
